<template>
  <PageWrapper>
    <NavbarMain />
    <BaseAlertMessage />
    <ProfileWrapper/>
    <Footer />
  </PageWrapper>
</template>

<script>
import PageWrapper from '@/components/_shared/PageWrapper.vue'
import NavbarMain from '@/components/_shared/navbar-main/NavbarMain.vue'
import ProfileWrapper from '@/components/profile/ProfileWrapper.vue'
import Footer from '@/components/_shared/Footer.vue'

export default {
  name: 'ProfileView',
  components: {
    PageWrapper,
    NavbarMain,
    ProfileWrapper,
    Footer
  }
}
</script>
